<template>
    <div>
        <div>
            <b class="is-pulled-left">Tags</b>

            <a class="is-pulled-right">
                <tag-picker :space="space" :exclude="exclude" @select="add_tag">
                    <template v-if="!loading">
                        Add &nbsp; <i class="fas fa-tags"></i>
                    </template>

                    <div v-else class="loader"></div>
                </tag-picker>
            </a>

            <div class="is-clearfix"></div>
        </div><br/>

        <div v-if="card.note.note_tags.length > 0" class="note-tags tags">
            <tag v-for="tag in card.note.note_tags"
                @remove="remove(tag)"
                :show_remove="true"
                :color="tag.color"
                :name="tag.name"
                :key="tag.id"/>
        </div>
    </div>
</template>

<script>
import _map from 'lodash/map';
import { mapState } from 'vuex';
import Tag from '../tag/Tag.vue';
import TagPicker from '../tag/TagPicker.vue';

export default {
    components: { Tag, TagPicker },
    props: ['space', 'column', 'card', 'in_note_editor'],
    computed: {
        ...mapState('tags', ['remove_note_tag', 'create_note_tag']),
        loading() {
            return this.remove_note_tag.loading || this.create_note_tag.loading;
        },
        exclude() {
            return _map(this.card.note.note_tags, 'system_tag_id');
        },
    },
    methods: {
        async remove(tag) {
            await this.$store.dispatch('tags/remove_note_tag', {
                space_id: this.space.id,
                note_id: this.card.note.id,
                tag_id: tag.id,
            });

            if (this.in_note_editor) {
                this.$store.commit('cards/remove_tag_from_detail', { tag_id: tag.id });
                return;
            }

            this.$store.commit('cards/remove_tag', {
                column_id: this.column,
                card_id: this.card.id,
                tag_id: tag.id,
            });
        },
        async add_tag(selected_tag) {
            const note_tag = await this.$store.dispatch('tags/create_note_tag', {
                space_id: this.space.id,
                note_id: this.card.note.id,
                name: selected_tag.name,
            });

            this.$store.commit('cards/add_tag', {
                column_id: this.column,
                card_id: this.card.id,
                note_tag,
            });
        },
    },
};
</script>
+99897 308 41 00
